import React from 'react';
import { CheckCircleIcon } from 'lucide-react';
const topics = ['History and prevalence of active shooter events', 'Case/event studies', 'Civilian response options', 'Situational awareness scenarios', 'Law enforcement response/arrival', 'Medical issues', 'Considerations for independent skill development'];
export function TopicsCovered() {
  return <div className="w-full" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-1319">
      <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-1320">
        <div className="mb-12" data-id="element-1321">
          <h2 className="text-2xl md:text-3xl font-bold uppercase mb-6" style={{
          fontFamily: 'Oswald, sans-serif',
          color: '#1e3d2f'
        }} data-id="element-1322">
            Topics Covered
          </h2>
          <div className="bg-white rounded-xl p-6 md:p-8 shadow-sm border" style={{
          borderColor: '#ede9e0'
        }} data-id="element-1323">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-1324">
              {topics.map(topic => <div key={topic} className="flex items-start gap-3" data-id="element-1325">
                  <CheckCircleIcon size={18} className="flex-shrink-0 mt-0.5" style={{
                color: '#1e3d2f'
              }} data-id="element-1326" />
                  <span className="text-base text-gray-800" style={{
                fontFamily: 'Inter, sans-serif'
              }} data-id="element-1327">
                    {topic}
                  </span>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </div>;
}